<script setup lang="ts">
type Props = {
  title: string;
  onBack?: AccountMenu.Groups;
  backFunction?: () => void;
};

const { title, onBack, backFunction } = defineProps<Props>();

const { isLayoutMobileOrTablet } = useLayout();
const { topBarHeight, headerHeight } = useLayout();

const stickyTop = computed<string>(() => {
  return `${headerHeight.value + topBarHeight.value}px`;
});

const handleTitleClick = () => {
  if (!isLayoutMobileOrTablet.value) {
    return;
  }

  if (backFunction) {
    backFunction();
  } else if (onBack) {
    navigateTo({
      path: localeLink('/user/wallet'),
      query: {
        select: onBack,
      },
    });
  } else {
    navigateTo({
      path: localeLink('/user/wallet'),
    });
  }
};
</script>

<template>
  <div
    :class="[$style.accountTitle]"
    @click="handleTitleClick"
  >
    <NuxtIcon
      :class="$style.itemIcon"
      name="arrows/angle_left"
    />
    <span :class="$style.itemText">{{ title }}</span>
    <div
      :class="$style.slotContent"
      @click="(e: any) => e.stopPropagation()"
    >
      <slot />
    </div>
  </div>
</template>

<style module lang="postcss">
.accountTitle {
  @apply w-full py-[11px] rounded-md flex items-center justify-center px-4 bg-bg-secondary text-texts/90 cursor-pointer md:cursor-default sticky z-30 md:static md:z-auto h-[50px];

  border-radius: 10px;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  padding: 20px;
  gap: 10px;

  top: v-bind(stickyTop);

  &:before {
    @apply content-[''] w-full h-full absolute top-0 left-0 -z-10;
  }

  .itemIcon {
    @apply text-lg opacity-70 text-primary cursor-pointer md:hidden;
  }

  .itemText {
    @apply uppercase text-xs w-full text-start font-bold;
  }

  .slotContent {
    @apply ml-auto cursor-default;
  }
}
</style>
